class PromiseTracker {
    constructor($timeout, $scope) {
        this.active = false
        this.timeout = $timeout
        this.id = Math.random()
        
        $scope.$tracker = this
    }

    $onChanges(changes) {
        if(changes.promise) {
            this.subscribe(changes.promise.currentValue)
        }
    }

    subscribe(promise) {
        if(promise) {
            this.active = true
            this.error = false
            this.currentPromise = promise
            promise
                .then(() => {
                    if (this.currentPromise === promise)
                        this.timeout(() => this.active = false)
                })
                .catch(e => {
                    if (this.currentPromise === promise)
                        this.timeout(() => {
                            this.active = false
                            this.error = true
                        })

                    throw e
                })
        }
    }
}

angular
    .module('eficienciaFiscalModule')
    .component('promiseTracker', {
        controller: ['$timeout', '$scope', PromiseTracker],
        transclude : true,
        bindings: {
            promise: '<',
            active: '=?',
            error: '=?'
        },
        template: `
            <ng-transclude></ng-transclude>
        `
    })
